import React from 'react';
import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import NavDropdown from 'react-bootstrap/NavDropdown';
import { Link } from 'react-router-dom';
import './Navbar.css';

const AMenu = () => {
  return (
    <Navbar className="main-navbar" expand="lg" collapseOnSelect>
      <Container fluid className="navbar-container">
        <Navbar.Brand as={Link} to="/" className="navbar-brand">
          <img
            src="/Images/logo512-new.webp"
            width="40"
            height="40"
            className="me-2"
            alt="English Exam Exercises logo"
          />
          English Teaching Materials
        </Navbar.Brand>

        <Navbar.Toggle 
          className="navbar-toggler-custom"
          aria-controls="responsive-navbar-nav"
          aria-label="Toggle navigation"
        >
          {/* Three separate lines rather than an icon-pack path: a burger has to
             rotate its own strokes to form the X, which one <path> cannot do. */}
          <svg
            className="navbar-toggler-icon"
            viewBox="0 0 30 30"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            aria-hidden="true"
            focusable="false"
          >
            <line className="navbar-toggler-bar navbar-toggler-bar-top" x1="5" y1="7" x2="25" y2="7" />
            <line className="navbar-toggler-bar navbar-toggler-bar-middle" x1="5" y1="15" x2="25" y2="15" />
            <line className="navbar-toggler-bar navbar-toggler-bar-bottom" x1="5" y1="23" x2="25" y2="23" />
          </svg>
        </Navbar.Toggle>

        <Navbar.Collapse id="responsive-navbar-nav" className="navbar-collapse-custom">
          <Nav className="me-auto navbar-nav-custom">
            <Nav.Link as={Link} to="/" eventKey="/" href="/">Home</Nav.Link>
            <Nav.Link as={Link} to="/lesson-plans" eventKey="/lesson-plans" href="/lesson-plans">Lesson Plans</Nav.Link>
            <Nav.Link as={Link} to="/grammar-exercises" eventKey="/grammar-exercises" href="/grammar-exercises">Grammar</Nav.Link>
            <Nav.Link as={Link} to="/vocabulary-exercises" eventKey="/vocabulary-exercises" href="/vocabulary-exercises">Vocabulary</Nav.Link>
            <Nav.Link as={Link} to="/reading-exercises" eventKey="/reading-exercises" href="/reading-exercises">Reading</Nav.Link>
            <Nav.Link as={Link} to="/speaking-exercises" eventKey="/speaking-exercises" href="/speaking-exercises">Speaking</Nav.Link>
            <Nav.Link as={Link} to="/videos" eventKey="/videos" href="/videos">Videos</Nav.Link>

            <NavDropdown title="Resources" id="collapsible-nav-dropdown" className="nav-dropdown-custom">
              <NavDropdown.Item as={Link} to="/level-test/level-test" eventKey="/level-test/level-test">Level Test</NavDropdown.Item>
              <NavDropdown.Item as={Link} to="/teach-english" eventKey="/teach-english">Teach English</NavDropdown.Item>
              <NavDropdown.Divider />
              <NavDropdown.Item as={Link} to="/privacy-policy" eventKey="/privacy-policy">Privacy Policy</NavDropdown.Item>
              <NavDropdown.Item as={Link} to="/terms-of-service" eventKey="/terms-of-service">Terms of Service</NavDropdown.Item>
              <NavDropdown.Item as={Link} to="/contact" eventKey="/contact">Contact</NavDropdown.Item>
            </NavDropdown>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};

export default AMenu;